import { render, staticRenderFns } from "./order-action.vue?vue&type=template&id=6f346a7d"
import script from "./order-action.vue?vue&type=script&lang=js"
export * from "./order-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports